export default() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = process.env.crispId;
  
    (function() {
        var d = document;
        var s = d.createElement("script");

        s.src = "https://client.crisp.chat/l.js";
        s.async = 1;
        d.getElementsByTagName("head")[0].appendChild(s);
    })();

    // window.CRISP_RUNTIME_CONFIG = {
    //     lock_maximized: true,
    //     lock_full_view: true,
    //     cross_origin_cookies: true
    // };
    
    $crisp.push(["on", "session:loaded", (event) => {
        $crisp.push(["do", "chat:hide"]);
        // $crisp.push(["do", "chat:open"]);
    }]);
};